"use client";

import { ReactNode } from "react";

import { ProfileTabs } from "./ProfileTabs";

interface IUserProfilePageProps {
  tab: string;
  children: ReactNode;
}

export function UserProfilePage({
  tab,
  children,
}: Readonly<IUserProfilePageProps>): JSX.Element {
  return (
    <div className="flex flex-col gap-y-10 items-center mt-5">
      <ProfileTabs tab={tab} />
      <div className="w-full">{children}</div>
    </div>
  );
}
